<template>
  <div style="max-height: 700px; overflow-x: hidden;">
    <b-row>
      <b-col cols="12">
        <h6 class="font-weight-bold">Endpoint</h6>
      </b-col>
      <b-col cols="3">
        <b-form :class="{'error-input' : $v.dataSetup.method.$error}">
          <label> Method </label>
          <j-single-select
            v-model="$v.dataSetup.method.$model"
            :options="methodOptions"
            :placeholder="'Select method'"
            label="label"/>
        </b-form>
      </b-col>
      <b-col cols="9">
        <b-form :class="{'error-input' : $v.dataSetup.url.$error}">
          <label> Url </label>
          <j-input
            v-model="$v.dataSetup.url.$model"
            placeholder="Enter url here"/>
        </b-form>
      </b-col>
    </b-row>

    <b-form :class="{'error-input' : $v.dataSetup.source.$error}">
      <label> Source </label>
      <j-input
        v-model="$v.dataSetup.source.$model"
        placeholder="Enter source here"/>
    </b-form>

    <b-row>
      <b-col cols="12">
        <h6 class="font-weight-bold">Header</h6>
      </b-col>
      <b-col cols="12">
        <div
          v-for="(data, index) in dataSetup.header"
          :key="index + 0"
          class="list-column-ui">
          <b-row>
            <b-col
              cols="1"
              lg="1"
              class="d-flex align-items-center justify-content-center cursor-pointer">
              <i class="fa fa-lg fa-ellipsis-v"/>
            </b-col>
            <b-col
              cols="10"
              lg="5">
              <b-form>
                <label> Name </label>
                <j-input
                  v-model="data.name"
                  placeholder="Enter name here"/>
              </b-form>
            </b-col>
            <b-col
              cols="10"
              lg="5">
              <b-form>
                <label> Value </label>
                <j-input
                  v-model="data.value"
                  placeholder="Enter key here"/>
              </b-form>
            </b-col>
            <b-col
              cols="1"
              lg="1"
              class="d-flex align-items-center justify-content-center cursor-pointer">
              <i
                class="fa fa-lg fa-trash"
                @click="deleteHeader(index)"
              />
            </b-col>
          </b-row>
        </div>

        <b-row>
          <b-col cols="12">
            <button
              class="btn btn-add-column"
              @click="addHeader"
            >
              + Add header
            </button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row v-if="dataSetup.method === 'GET'">
      <b-col cols="12">
        <h6 class="font-weight-bold">Params</h6>
      </b-col>
      <b-col cols="12">
        <div
          v-for="(data, index) in dataSetup.params"
          :key="index + 0"
          class="list-column-ui">
          <b-row>
            <b-col
              cols="1"
              lg="1"
              class="d-flex align-items-center justify-content-center cursor-pointer">
              <i class="fa fa-lg fa-ellipsis-v"/>
            </b-col>
            <b-col
              cols="10"
              lg="5">
              <b-form>
                <label> Variable </label>
                <j-input
                  v-model="data.variable"
                  placeholder="Enter Variable here"/>
              </b-form>
            </b-col>
            <b-col
              cols="10"
              lg="5">
              <b-form>
                <label> Value </label>
                <j-input
                  v-model="data.value"
                  placeholder="Enter key here"/>
              </b-form>
            </b-col>
            <b-col
              cols="1"
              lg="1"
              class="d-flex align-items-center justify-content-center cursor-pointer">
              <i
                class="fa fa-lg fa-trash"
                @click="deleteParams(index)"
              />
            </b-col>
          </b-row>
        </div>

        <b-row>
          <b-col cols="12">
            <button
              class="btn btn-add-column"
              @click="addParams"
            >
              + Add params
            </button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row v-else>
      <b-col cols="12">
        <h6 class="font-weight-bold">Payload</h6>
      </b-col>
      <b-col cols="4">
        <b-form>
          <label> Content Type </label>
          <j-single-select
            v-model="dataSetup.payload.type"
            :options="payloadOptions"
            :placeholder="'Select type'"
            value-format="object"
            label="label"/>
        </b-form>
      </b-col>
      <b-col cols="12">
        <b-form>
          <label> Body </label>
          <label
            v-if="isJson"
            class="float-right text-primary cursor-pointer"
            @click="jsonBeautify">
            Beautify
          </label>
          <j-textarea
            v-model="dataSetup.payload.body"
            placeholder="Enter body here"
          />
        </b-form>
      </b-col>
    </b-row>

    <div class="pull-right m__b--10">
      <b-button
        class="btn gray"
        @click="$emit('close-modal')">
        Close
      </b-button>
      <b-button
        class="btn blue"
        @click="submitForm">
        Apply
      </b-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-nested-ternary, max-len */
import { required } from 'vuelidate/lib/validators';
import draggable from 'vuedraggable';
// import { mapActions, mapState } from 'vuex';

export default {
  components: {
    draggable,
  },
  validations: {
    dataSetup: {
      method: {
        required,
      },
      url: {
        required,
      },
      source: {},
      header: {},
      params: {},
      variable: {},
      payload: {
        type: {
          // required,
        },
        body: {
          // required,
        },
      },
    },
  },
  props: {
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dataSetup: {
        method: null,
        url: null,
        source: null,
        header: [],
        params: [],
        variable: [],
        payload: {
          type: null,
          body: null,
        },
      },
      methodOptions: [
        {
          id: 'GET',
          label: 'GET',
          text: 'GET',
        },
        {
          id: 'POST',
          label: 'POST',
          text: 'POST',
        },
        {
          id: 'PUT',
          label: 'PUT',
          text: 'PUT',
        },
        {
          id: 'PATCH',
          label: 'PATCH',
          text: 'PATCH',
        },
        {
          id: 'DELETE',
          label: 'DELETE',
          text: 'DELETE',
        },
      ],
      payloadOptions: [
        // {
        //   id: 'json',
        //   label: 'JSON',
        //   text: 'JSON',
        // },
        {
          id: 'raw',
          label: 'RAW',
          text: 'RAW',
        },
      ],
    };
  },
  computed: {
    isJson() {
      if (this.dataSetup.payload.type) {
        if (this.dataSetup.payload.type.id === 'json') {
          return true;
        }
      }
      return false;
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'dataSetup.payload.type': function (val) {
      if (val.id === 'json' && this.dataSetup.payload.body) {
        this.jsonBeautify();
      }
    },
  },
  created() {
    if (this.dataEdit) {
      // eslint-disable-next-line
      const { method, url, source, header, query_params, body, variables } = this.dataEdit;
      this.dataSetup.method = method;
      this.dataSetup.url = url;
      this.dataSetup.source = source;
      this.dataSetup.payload.type = { id: 'raw' };
      this.dataSetup.payload.body = body;

      const headerData = Object.keys(header);
      const headerValueData = Object.values(header);
      this.dataSetup.header = headerData.map((e, index) => ({
        name: e,
        value: headerValueData[index],
      }));

      const paramsData = Object.keys(query_params);
      const paramsValueData = Object.values(query_params);
      this.dataSetup.params = paramsData.map((e, index) => ({
        variable: e,
        value: paramsValueData[index],
      }));

      // const variableData = Object.keys(variables);
      // const variableValueData = Object.values(variables);
      // this.dataSetup.variable = variableData.map((e, index) => ({
      //   variable: e,
      //   value: variableValueData[index],
      // }));
    }
  },
  methods: {
    addHeader() {
      this.dataSetup.header.push({
        name: null,
        value: null,
      });
    },
    deleteHeader(index) {
      this.dataSetup.header.splice(index, 1);
    },
    addParams() {
      this.dataSetup.params.push({
        variable: null,
        value: null,
      });
    },
    deleteParams(index) {
      this.dataSetup.params.splice(index, 1);
    },
    addVariable() {
      this.dataSetup.variable.push({
        variable: null,
        value: null,
      });
    },
    deleteVariable(index) {
      this.dataSetup.variable.splice(index, 1);
    },
    jsonBeautify() {
      let formatted = '';
      try {
        const toJson = JSON.parse(this.dataSetup.payload.body);
        formatted = JSON.stringify(toJson, undefined, 4);
      } catch (error) {
        this.$store.dispatch('jStoreNotificationScreen/toggleProblem', error.message);
        formatted = this.dataSetup.payload.body;
      }
      this.dataSetup.payload.body = formatted;
    },
    submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        const { method, url, source, header, params, variable, payload } = this.dataSetup;

        const dataHeader = {};
        header.forEach((element) => {
          dataHeader[element.name] = element.value;
        });
        const dataParams = {};
        params.forEach((element) => {
          dataParams[element.variable] = element.value;
        });
        const dataVariable = {};
        variable.forEach((element) => {
          dataVariable[element.variable] = element.value;
        });
        const newVal = {
          url,
          method,
          source,
          header: dataHeader,
          query_params: dataParams,
          body: payload.body,
          // variables: dataVariable,
        };
        this.$emit('submit-data', newVal);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager/external-api/jExternalApiField.vue